import { Editor, ModelDocumentFragment, ModelDocumentSelection, ModelElement } from "ckeditor5";

export function areaIdsToAreaNames(editor: Editor, areaIds: string | string[]): string {
  if (!areaIds) {
    return "";
  }
  const areaIdsArray: string[] = Array.isArray(areaIds) ? areaIds : areaIds.split(",");
  const areaNamesArray: string[] = [];
  const privilegedAreas = getPrivilegedAreas(editor);
  const invalidRoleName = editor.config.get("privilegedArea.invalidRoleName") as string;
  for (let i = 0; i < areaIdsArray.length; ++i) {
    const areaId = areaIdsArray[i].trim();
    let areaName: string = privilegedAreas[areaId];
    if (!areaName) {
      areaName = invalidRoleName;
    }
    areaNamesArray[i] = areaName;
  }
  return areaNamesArray.join(", ");
}

export function getPrivilegedAreas(editor: Editor): Record<string, string> {
  return (editor.config.get("privilegedArea.roles") || {}) as Record<string, string>;
}

export function getPrivilegedAreaElement(selection: ModelDocumentSelection): ModelElement | null {
  const selectionPosition = selection.getFirstPosition();
  if (!selectionPosition) {
    return null;
  }
  const selectedElement = selection.getSelectedElement();
  if (selectedElement) {
    const sectionElement = _getPrivilegedAreaElementFromElement(selectedElement);
    if (sectionElement) {
      return sectionElement;
    }
  }
  const selectionParent = selectionPosition.parent;
  if (selectionParent.is("element")) {
    let node: ModelElement | ModelDocumentFragment | null = selectionParent;
    while (node) {
      if (node instanceof ModelElement && node.is("element")) {
        const sectionElement = _getPrivilegedAreaElementFromElement(node);
        if (sectionElement) {
          return sectionElement;
        }
        node = node.parent;
      } else {
        node = null;
      }
    }
  }
  return selectionPosition.findAncestor("privilegedArea");
}

function _getPrivilegedAreaElementFromElement(element: ModelElement): ModelElement | null {
  if (element.name == "privilegedArea") {
    return element;
  }
  return null;
}
